// UID mapping configuration
const uidMappings = {
  qkRgkCHXysTbObgVoi56kLmyLtm1: 'yxvWA76upHdUeBckB6BLLIBmgx02',
  NAOwggpyW4RRoajO6xw0jywzESN2: 'DH98P2S6xRSWXD0erypEPnX2yWV2',
  // Add more mappings here as needed
}

/**
 * Maps an existing UID to a new UID if a mapping exists
 * @param {string} uid - The original UID to check
 * @returns {string} - The mapped UID if found, otherwise returns the original UID
 */
export const mapUid = (uid) => {
  return uidMappings[uid] || uid
}
